import { StyleSheet, Text, View } from 'react-native'
import { TemplatePage } from '../../../../../components/TemplatePage'
import { globalStyle } from '../../../../../theme/global'
import { useContext } from 'react'
import { NecropsyContext } from '../../../../../context/Necropsy/Provider'
import { CommonActions, useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { NecropsyRoutes } from '../../../../../navigator/types'
import { SuccessIcon } from '../../../../../components/Svg'
import { Separator } from '../../../../../components/Separator'
import { lightBlue, textColor, toqueColor } from '../../../../../theme/colors'
import { Button } from '../../../../../components/Button'
import { DOBRA } from '../../../../../theme/fonts'
import { useTranslation } from 'react-i18next'
interface NavigationParams extends StackNavigationProp<NecropsyRoutes, 'Success'> {}

export const SuccessNecropsy = () => {
  const { resetForm } = useContext(NecropsyContext)
  const { t } = useTranslation()
  const navigation = useNavigation<NavigationParams>()

  const successAction = () => {
    resetForm()
    navigation.dispatch(
      CommonActions.reset({
        index: 1,
        routes: [
          { name: 'HomeScreen' },
          {
            name: 'NecropsyStack',
            params: {
              screen: 'Necropsy',
            },
          },
        ],
      }),
    )
  }

  const cancelAction = () => {
    resetForm()
    navigation.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: 'HomeScreen' }],
      }),
    )
  }
  return (
    <TemplatePage styleContent={{ padding: 0, marginBottom: 0 }} header title=''>
      <View style={[globalStyle.viewContainer, { padding: 20 }]}>
        <View style={{ justifyContent: 'center', alignItems: 'center', flex: 1 }}>
          <SuccessIcon height={40} width={40} />
          <Text style={styles.title}>{t('FICHA GUARDADA')}</Text>
          <Separator customStyle={styles.separator} />

          <Text style={styles.subTitle}>
            {t('La ficha fue guardada correctamente. ¿Desea crear una nueva ficha?')}
          </Text>
        </View>

        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            label={t('Terminar')}
            onPress={cancelAction}
            customStyle={{
              width: 177,
              height: 60,
              backgroundColor: lightBlue,
              justifyContent: 'center',
            }}
          />
          <Button
            label={t('Crear nueva ficha')}
            onPress={successAction}
            customStyle={{
              width: 177,
              height: 60,
              backgroundColor: toqueColor,
              justifyContent: 'center',
            }}
          />
        </View>
      </View>
    </TemplatePage>
  )
}

const styles = StyleSheet.create({
  separator: {
    borderBottomWidth: 3,
    width: 31,
    borderBottomColor: toqueColor,
    marginBottom: 24,
    marginTop: 10,
  },
  title: {
    fontFamily: DOBRA,
    fontSize: 18,
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 22,
    color: textColor,
  },

  subTitle: {
    fontFamily: DOBRA,
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: '400',
    width: 283,
    textAlign: 'center',
    color: textColor,
  },
})
